import { Button, Modal, ModalContent, ModalHeader, ModalOverlay, Divider, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import api from 'services/api'
import { useEffect, useState } from 'react'
import { SingleValue } from 'chakra-react-select'
import SelectDropDown from 'components/SelectDropDown'

type AddCourseModalProps = {
  isOpen: boolean
  onClose: () => void
  getCourses: () => void
  course: string
  users: any[]
}

type AddCourseDataForm = {
  name: string
}

export default function AddUserCourseModal(props: AddCourseModalProps) {
  const { isOpen, onClose, getCourses, course, users } = props
  const { handleSubmit } = useForm<AddCourseDataForm>()
  const toast = useToast()
  const [selectedUser, setSelectedUser] = useState<SingleValue<{ label: any; value: any }>>({ label: '', value: '' })

  function onSubmit() {
    api
      .post('/usercourses', {
        userId: selectedUser?.value,
        courseId: course,
      })
      .then((response) => {
        getCourses()
        onClose()
      })
      .catch((error) => {
        toast({
          title: 'Erro ao adicionar treinamento',
          description: error,
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Adicionar Participante</ModalHeader>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            maxWidth: '18.75rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginInline: 'auto',
            width: '100%',
          }}
        >
          <div style={{ position: 'relative' }}>
            <SelectDropDown
              placeholder="Selecionar"
              noOptionsMessage={() => 'Nenhum encontrado'}
              options={users.map((user) => ({
                label: user.name,
                value: user.id,
              }))}
              onChange={(e) => {
                setSelectedUser(e)
              }}
            />
          </div>
          <Divider marginY="0.5rem" size="0.125rem" />
          <Button type="submit" marginY="1.25rem" width="100%" colorScheme="yellow" textColor="white">
            Adicionar
          </Button>
        </form>
      </ModalContent>
    </Modal>
  )
}
